import React from 'react'
import './TableStatus.scss'
const TableStatus = props => {
  const status = props.status
  if (!status) {
    return null
  }
  let content = props.content
  if (status === 'LOADING'){
    content = (<div data-testid='tableStatusLoader' className='loader'/>)
  } else if (status === 'EMPTY'){
    content = (<span data-testid='tableStatusPrompt'>{props.prompt ? props.prompt: 'No data'}</span>)
  }

  return (
    <div className='w100% h100 df jcc aic'>
      {content}
    </div>
  )
}

export default TableStatus